import { TopicSubject } from '../../../interfaces/topic.interface';
import { SvgIconName } from '../../../shared/SvgIcon';

interface TopicTypeI {
  value: TopicSubject;
  name: string;
  iconName: SvgIconName;
  description: string;
}

export const topicTypes: TopicTypeI[] = [
  {
    value: TopicSubject.General,
    name: 'x.topics.add.type.pulse',
    iconName: 'iconPulse',
    description: 'x.topics.add.pulse.description',
  },
  {
    value: TopicSubject.People,
    name: 'x.topics.add.type.people',
    iconName: 'iconPeople',
    description: 'x.topics.add.people.description',
  },
  {
    value: TopicSubject.Groups,
    name: 'x.topics.add.type.attribute',
    iconName: 'iconGroups',
    description: 'x.topics.add.attributes.description',
  },
];
